import type { InputHTMLAttributes, ReactNode, Ref } from 'react';
import { useFormFieldContext } from './form-field-context';
import styles from './Input.module.css';

// `size` HTML'de sayisaldir (<input size="20">); bizim ton/olcu anlamimizla
// cakisiyor ve kesisim tipi `never` uretiyor. Yerel olani cikariyoruz.
export type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> & {
  /** react-hook-form'un register() ile verdigi ref dogrudan gecirilebilir (React 19). */
  ref?: Ref<HTMLInputElement>;
  size?: 'sm' | 'md';
  /** Sol taraftaki simge/on ek (para birimi, arama ikonu…). */
  prefix?: ReactNode;
  /** Sag taraftaki ek (birim, temizle butonu…). */
  suffix?: ReactNode;
  /** Sayisal alanlarda rakamlari hizalar — kur/tutar girisleri icin. */
  numeric?: boolean;
};

export function Input({
  size = 'md',
  prefix,
  suffix,
  numeric = false,
  className,
  id,
  'aria-describedby': describedBy,
  'aria-invalid': ariaInvalid,
  ...rest
}: InputProps) {
  const field = useFormFieldContext();

  return (
    <div
      className={[
        styles.wrapper,
        styles[size],
        field?.invalid ? styles.invalid : undefined,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {prefix ? <span className={styles.affix}>{prefix}</span> : null}
      <input
        id={id ?? field?.controlId}
        aria-describedby={describedBy ?? field?.describedBy}
        aria-invalid={ariaInvalid ?? (field?.invalid ? true : undefined)}
        className={[styles.input, numeric ? styles.numeric : undefined].filter(Boolean).join(' ')}
        {...rest}
      />
      {suffix ? <span className={styles.affix}>{suffix}</span> : null}
    </div>
  );
}
